import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { NotificationPermissionModalComponent } from '../components/notification-permission-modal/notification-permission-modal.component';
import { PushNotificationService } from './push-notification.service';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class NotificationPermissionService {
  private modalCtrl = inject(ModalController);
  private pushService = inject(PushNotificationService);

  async requestPermission(): Promise<boolean> {
    const modal = await this.modalCtrl.create({
      component: NotificationPermissionModalComponent,
      cssClass: 'notification-permission-modal',
      focusTrap: true,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    const granted = data?.granted ?? false;

    if (granted) {
      // After the user accepts, retrieve the native subscription ID and register the device
      if (Capacitor.isNativePlatform()) {
        try {
          const OneSignalCap = await import('@onesignal/capacitor-plugin');
          const subId = await OneSignalCap.default.User.pushSubscription.getIdAsync();
          if (subId) {
            this.pushService.setPlayerId(subId);
            const platform = Capacitor.getPlatform() === 'ios' ? 'ios' : Capacitor.getPlatform() === 'android' ? 'android' : 'web';
            await this.pushService.registerDevice(platform);
          }
        } catch (error) {
          console.error('Failed to set up push after permission grant:', error);
        }
      } else {
        // Web: player ID should have been set during init; ensure registration
        if (this.pushService.ready()) {
          await this.pushService.registerDevice('web');
        }
      }
    }

    return granted;
  }
}
